import { Component, ViewContainerRef, Renderer2 } from '@angular/core';
import { ToolBarService } from '../tool-bar.service';
import { DataTableComponent } from '../../data-table.component';
import { of } from 'rxjs';
import { ToolBarComponent } from '../tool-bar.component';

@Component({
    selector: 'data-table-print-options',
    templateUrl: './print-options.component.html',
    styleUrls: ['./print-options.component.scss'],
    standalone: false
})
export class PrintOptionsComponent {
    printOptions = [PrintType.CSV]// Object.values(PrintType);

    constructor(
        public _toolbar: ToolBarComponent,
        public _toolbarService: ToolBarService,
        public _dataTable: DataTableComponent,
        public _renderer:  Renderer2
    ) { }

	print(type: PrintType) {
		const printable = this._dataTable.columns.filter(column => column.printable);
		const cols = this._toolbarService.grid.api.getAllDisplayedColumns()
			.filter(x => printable.find(y => y.name === x.getColDef().headerName));

		switch (type) {
			case PrintType.CSV:
				this._toolbarService.grid.api.exportDataAsCsv({ columnKeys: cols });
				break;
			default:
				// Use ViewContainerRef.createComponent instead of deprecated ComponentFactoryResolver
				const portal: ViewContainerRef = this._toolbar.portal;
				portal.clear();
				const compRef = portal.createComponent(DataTableComponent);
				compRef.location.nativeElement.id = "grid";
				const el = compRef.location.nativeElement;
				this._renderer.setStyle(window.document.body, 'visibility', 'hidden');
				this._renderer.setAttribute(el, 'style', 'visibility: visible; position:fixed; left:0; top:0; width:8.5in; height:11in');

				compRef.instance.gridOptions = {
					...this._dataTable.gridOptions,
					pagination: false,
					paginationAutoPageSize: false,
				};
				compRef.instance.columns = printable;
				compRef.instance.settings = {
					...this._dataTable.settings,
					toolbars: []
				};
				compRef.instance.dataset = of(this._dataTable.resolvedData);
				compRef.changeDetectorRef.detectChanges();
				compRef.instance.grid.api.sizeColumnsToFit();
				(window as any).print();

				portal.clear();
				this._renderer.removeStyle(window.document.body, 'visibility');
				break;
		}
	}
}

enum PrintType {
    Print = "Print",
    CSV = "CSV",
}
